import i18n from "i18n-js";
import en from "./translations/english";
import ar from "./translations/arabic";

const STORAGE_KEY = "vxpro_locale";

i18n.translations = { en, ar };
i18n.fallbacks = true;

export const initLocalization = () => {
  const savedLang = localStorage.getItem(STORAGE_KEY);
  const defaultLocale =
    savedLang || navigator.language?.split("-")[0] || "en";
  i18n.locale = defaultLocale;
  return defaultLocale;
};

export const changeLanguage = (lang) => {
  i18n.locale = lang;
  localStorage.setItem(STORAGE_KEY, lang);
};

export default i18n;
